<template>
  <div class="page-treatInfo" :style="{ maxHeight: 'calc(100vh - 215px)', minHeight: '500px' }">
    <div class="calendar-list">
      <div class="treatInfo-title dot success">日历</div>
      <caring-calendar
        ref="calendar"
        :errors="calendarErrors"
        :successes="calendarSuccesses"
        :dots="calendarDots"
        @change-date="getCalendarDetail"
        @change-month="getCalendar"
      />
      <div v-if="currentCalendarLoading" style="position: relative">
        <div
          style="
            display: inline-block;
            width: 100%;
            height: 300px;
            position: relative;
          "
        >
          <Spin size="large" fix></Spin>
        </div>
      </div>
      <div class="calendar-btn-wrap" v-else-if="currentCalendar.length">
        <activity-wrap v-for="l in currentCalendar" :key="l.id" :l="l"
          :is_redirect="true" style="margin-top: 16px" @on-click="editActivity" />
      </div>
      <div v-else style="position: relative; height: 300px">
        <caringNoData></caringNoData>
      </div>
    </div>
    <div class="content-list">
      <div
        v-if="treatList.length"
        :class="['treatInfo-title', 'dot', 'success',
        currentTreatObj.medicine_status === 1 ? 'warning' : '',
        currentTreatObj.status === 0 ? 'error' : ''
      ]"
      >
        <Dropdown @on-click="handleChangeTreat">
          <span style="cursor: pointer">
            {{ currentTreatObj.name }}
            <Icon type="ios-arrow-down"></Icon>
          </span>
          <DropdownMenu slot="list">
            <DropdownItem v-for="t in treatList" :name="t.id" :key="t.id">
              {{
              t.name
              }}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <el-tooltip
          v-if="currentTreatObj.reason"
          class="content-reason"
          effect="dark"
          placement="bottom-end"
        >
          <span>{{currentTreatObj.status === 0 ? '暂停' : '重启'}}原因: {{ currentTreatObj.reason }}</span>
          <div
            slot="content"
          >{{(currentTreatObj.status === 0 ? '暂停' : '重启') + '原因:' + currentTreatObj.reason}}</div>
        </el-tooltip>
      </div>
      <div v-if="treatList.length" class="treat-operate-btns">
        <el-button
          class="treat-operate-btn"
          type="primary"
          size="medium"
          plain
          round
          @click="editRow"
        >修改方案</el-button>
        <el-button
          v-if="
            currentTreatObj.medicine_status == null ||
            currentTreatObj.medicine_status === 0
          "
          class="treat-operate-btn"
          type="primary"
          size="medium"
          plain
          round
          @click="pausePatientMedicine"
        >暂停用药</el-button>
        <el-button
          v-if="currentTreatObj.medicine_status === 1"
          class="treat-operate-btn"
          type="primary"
          size="medium"
          plain
          round
          @click="resumePatientMedicine"
        >重启用药</el-button>
        <el-button
          v-if="currentTreatObj.status === 1"
          class="treat-operate-btn"
          type="primary"
          size="medium"
          plain
          round
          @click="changeTemplateState(0)"
        >暂停方案</el-button>
        <el-button
          v-if="currentTreatObj.status === 0"
          class="treat-operate-btn"
          type="primary"
          size="medium"
          plain
          round
          @click="changeTemplateState(1)"
        >重启方案</el-button>
        <el-button
          class="treat-operate-btn"
          type="primary"
          size="medium"
          plain
          round
          @click="changeTemplateState(-1)"
        >终止方案</el-button>
        <el-button
          class="treat-operate-btn"
          type="primary"
          size="medium"
          plain
          round
          @click="changeTemplateState(2)"
        >完成方案</el-button>
      </div>
      <div ref="contentForm" class="content-form" style="width: 100%; margin-left: 0">
        <div :class="['content-form-item', formItemClass]">
          <Select v-model="query.template_id" placeholder="治疗阶段" @on-change="getContentList">
            <Option value key>全部</Option>
            <Option v-for="t in templateList" :key="t.id" :value="t.id">
              {{
              t.name
              }}
            </Option>
          </Select>
        </div>
        <div :class="['content-form-item', formItemClass]">
          <Select v-model="query.is_finish" placeholder="完成情况" @on-change="getContentList">
            <Option value key>全部</Option>
            <Option :value="0" :key="0">未完成</Option>
            <Option :value="1" :key="1">已完成</Option>
          </Select>
        </div>
        <div :class="['content-form-item', formItemClass]">
          <Select v-model="query.event_type" placeholder="活动类型" @on-change="getContentList">
            <Option value key>全部</Option>
            <Option :value="0" :key="0">例行活动</Option>
            <Option :value="1" :key="1">关键活动</Option>
            <Option :value="2" :key="2">临时活动</Option>
          </Select>
        </div>
        <div :class="['content-form-item', formItemClass]">
          <Select v-model="query.type" placeholder="日程类型" @on-change="getContentList">
            <Option value key>全部</Option>
            <Option v-for="t in type" :key="t.value" :value="t.value">
              {{
              t.text
              }}
            </Option>
          </Select>
        </div>
        <div :class="['content-form-item-date', formDateClass]">
          <DatePicker
            :value="query.time"
            :options="options"
            :transfer="true"
            confirm
            type="daterange"
            style="width: 100%"
            placement="bottom"
            placeholder="请选择起始时间至截止时间"
            @on-change="handleDateChange"
            @on-ok="handleDateConfirm"
            @on-clear="handleDateCancel"
          ></DatePicker>
        </div>
      </div>
      <div
        v-if="currentContentLoading"
        style="
          display: inline-block;
          width: 100%;
          height: 300px;
          position: relative;
        "
      >
        <Spin size="large" fix></Spin>
      </div>
      <div v-else-if="list.length" class="schedule-list">
        <div class="schedule-item" v-for="item in list" :key="item.key">
          <div class="schedule-title">{{ item.key }} {{ item.day }}</div>
          <activity-wrap v-for="l in item.list" :key="l.id" :l="l"
            :is_redirect="true" style="margin-top: 16px" @on-click="editActivity" />
        </div>
      </div>
      <div v-else style="position: relative; height: 300px">
        <caringNoData></caringNoData>
      </div>
    </div>
    <div class="key-list">
      <div class="treatInfo-title dot success">历史方案</div>
      <div
        v-if="historyLoading"
        style="
          display: inline-block;
          width: 100%;
          height: 300px;
          position: relative;
        "
      >
        <Spin size="large" fix></Spin>
      </div>
      <div v-else-if="historyList.length" style="overflow-y: scroll">
        <Card
          v-for="h in historyList"
          :key="h.id"
          style="margin-bottom: 12px; cursor: pointer"
          @click.native="handleHistoryClick(h)"
        >
          <div class="history-title">
            <span>{{ h.name }}</span>
            <span class="tag warning" v-if="h.status === -1">已终止</span>
            <span class="tag success" v-if="h.status === 2">已结束</span>
          </div>
          <div
            v-if="h.reason"
          >{{h.status === -1 ? '终止' : h.status === 2 ? '结束' : ''}}原因: {{ h.reason }}</div>
          <div>开始日期: {{ (h.start_time && h.start_time.slice(0, 10)) || "--" }}</div>
          <div v-if="h.status !== 0">结束日期: {{ (h.stop_time && h.stop_time.slice(0, 10)) || "--" }}</div>
          <div v-else>暂停日期: {{ (h.stop_time && h.stop_time.slice(0, 10)) || "--" }}</div>
        </Card>
      </div>
      <div v-else style="position: relative; height: 300px">
        <caringNoData></caringNoData>
      </div>
    </div>
    <activity-modal
      :value="modal"
      :title="modalTitle"
      :modalLoading="modalLoading"
      :dataSource="curActivity"
      @cancel="hideModal"
      @save="saveActivity"
    ></activity-modal>
    <Modal
      v-model="medicineModal"
      :mask-closable="false"
      width="500"
      @on-cancel="cancelMedicineResumeModal"
    >
      <div slot="header" style="text-align: center">
        <span>重启所有用药</span>
      </div>
      <div>
        <Form
          :label-width="160"
          label-position="right"
          style="margin-left: -40px;margin-right: 40px"
        >
          <FormItem required label="用药重启时间">
            <DatePicker
              v-model="curMedicine.date"
              type="date"
              :options="dateOptions"
              :clearable="false"
              placeholder="请选择用药重启时间"
              style="width: 100%"
            ></DatePicker>
          </FormItem>
          <!-- <FormItem required label="常规用药重启方式">
            <Select v-model="curMedicine.resume_way">
              <Option :value="0" :key="0">跳过</Option>
              <Option :value="1" :key="1">顺延</Option>
            </Select>
          </FormItem>-->
        </Form>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelMedicineResumeModal">取消</el-button>
        <el-button
          type="primary"
          round
          :loading="medicineModalLoading"
          @click="saveMedicineResumeModal"
        >保存</el-button>
      </div>
    </Modal>
    <Modal
      v-model="treatModal"
      :mask-closable="false"
      width="500"
      @on-cancel="cancelTreatResumeModal"
    >
      <div slot="header" style="text-align: center">
        <span>重启方案</span>
      </div>
      <div>
        <Form
          ref="form"
          :model="curModalTreat"
          :rules="rules"
          :label-width="160"
          label-position="right"
          style="margin-left: -40px;margin-right: 40px"
        >
          <FormItem required label="方案重启时间">
            <DatePicker
              v-model="curModalTreat.date"
              :options="dateOptions"
              type="date"
              placeholder="请选择方案重启时间"
              style="width: 100%"
            ></DatePicker>
          </FormItem>
          <FormItem required label="常规用药重启方式">
            <Select v-model="curModalTreat.resume_way">
              <Option :value="0" :key="0">跳过</Option>
              <Option :value="1" :key="1">顺延</Option>
            </Select>
          </FormItem>
          <FormItem label="重启原因" prop="reason">
            <Input
              v-model="curModalTreat.reason"
              type="textarea"
              :maxlength="100"
              :autosize="{ minRows: 2, maxRows: 4 }"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelTreatResumeModal">取消</el-button>
        <el-button
          type="primary"
          round
          :loading="treatModalLoading"
          @click="saveTreatResumeModal"
        >保存</el-button>
      </div>
    </Modal>
    <history-treat
      :value="historyModal"
      :user_id="info.user_id || info.patient_id"
      :title="historyTitle"
      :id="historyId"
      @cancel="historyModal = false"
    />
  </div>
</template>
<script>
import CaringCalendar from '../../../components/caring-calendar.vue'
import CaringTitle from '../../../components/caring-title.vue'
import ActivityModal from '../components/activityModal.vue'
import HistoryTreat from '../components/historyTreat.vue'
import {
  getPatientActivityListApi,
  getPatientSchemeListApi,
  getPatientCalendarApi,
  getPatientHistorySchemeListApi,
  pausePatientMedicineApi,
  resumePatientMedicineApi,
  clockPatientApi,
  changeTemplateStateApi,
  getPatientInfoApi,
  getSchemeDetailApi,
} from '../../../api/scheme'
import CaringNoData from '../../common/caringNoData.vue'
import ActivityWrap from '../components/activityWrap.vue'
import { formatDate } from '../../../utils/date'
const type = [
  {
    text: '用药',
    value: 'medicine',
  },
  {
    text: '宣教',
    value: 'article',
  },
  {
    text: '复诊',
    value: 'visit',
  },
  {
    text: '问卷',
    value: 'survey',
  },
]
const status = ['已停用', '进行中', '已结束']
export default {
  components: {
    CaringCalendar,
    ActivityWrap,
    ActivityModal,
    HistoryTreat,
    CaringNoData,
    CaringTitle,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      treatList: [], // 所有治疗方案列表
      currentTreat: '', // 当前治疗方案
      calendarList: [], // 日历所有数据列表
      currentCalendar: [], // 当天的日历所有数据
      currentCalendarLoading: false, // 当天的日历loading
      calendarDots: [], // 当天的日历有未完成的数据
      calendarErrors: [], // 当天的日历有未完成的数据
      calendarSuccesses: [], // 当天的日历已经完成的数据
      calendar: '',
      calendarRange: [],
      keyList: [], // 最近关键日程列表
      query: {
        template_id: '',
        is_finish: '',
        event_type: 1,
        type: '',
        time: [formatDate(new Date(), -6), formatDate(new Date(), 6)],
      },
      options: {
        shortcuts: [
          {
            text: '近一周',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            },
          },
          {
            text: '近一个月',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            },
          },
          {
            text: '近三个月',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end]
            },
          },
        ],
      }, // 时间options
      list: [],
      currentContentLoading: false, // 列表loading
      type,
      status,
      formItemClass: 'flex-6',
      formDateClass: 'flex-12',
      modal: false,
      modalTitle: '提示',
      modalLoading: false,
      curActivity: {},
      medicineModal: false,
      medicineModalLoading: false,
      curMedicine: {},
      dateOptions: {
        disabledDate(date) {
          const c = new Date(formatDate(new Date(), 1) + ' 00:00:00').getTime()
          return date && date.valueOf() < c
        },
      },
      treatModal: false,
      curModalTreat: {},
      treatModalLoading: false,
      historyList: [], // 历史方案库
      historyModal: false,
      historyTitle: '',
      historyId: '',
      historyLoading: false,
      rules: {
        reason: [
          { required: true, message: '请填写重启原因', trigger: 'blur' },
          { required: true, message: '请填写重启原因', trigger: 'change' },
        ],
      },
      templateList: [],
    }
  },
  watch: {
    currentTreat(newVal) {
      if (newVal) {
        this.query.template_id = ''
        this.getTemplate()
        this.getContentList()
        this.$refs.calendar.init()
      }
    },
  },
  computed: {
    currentTreatObj() {
      return this.treatList.find((t) => t.id === this.currentTreat) || {}
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.calcWidth()
    })
    window.addEventListener('resize', this.calcWidth, true)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcWidth, true)
  },
  methods: {
    editRow() {
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'schemeAdd',
        title: `编辑${this.info.name}${this.currentTreatObj.name}`,
        key: `schemeAdd?${this.currentTreat}`,
        extra: {
          id: this.currentTreat,
          patient_id: this.info.user_id,
        },
      })
    },
    saveArticle(cur, l) {
      this.modalLoading = true
      const { is_execute, remark, date, result } = cur
      clockPatientApi(
        l.id,
        {
          is_finish: 1,
          is_execute,
          remark: is_execute === 1 ? '' : remark,
          date: formatDate(date, null, 'yyyy-MM-dd hh:mm:ss'),
          result: is_execute === 1 ? '' : result,
        },
        l.extra
      )
        .then((res) => {
          this.modalLoading = false
          if (res.code === 0) {
            this.$Message.success('操作成功')
            this.modal = false
            this.getContentList()
            this.$refs.calendar.init()
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.modalLoading = false
        })
    },
    saveVisit(cur, l) {
      this.modalLoading = true
      const { is_execute, remark, date, result } = cur
      clockPatientApi(
        l.id,
        {
          is_finish: 1,
          is_execute,
          remark: is_execute === 1 ? '' : remark,
          date: formatDate(date, null, 'yyyy-MM-dd hh:mm:ss'),
          result: is_execute === 1 ? '' : result,
        },
        l.extra
      )
        .then((res) => {
          this.modalLoading = false
          if (res.code === 0) {
            this.$Message.success('操作成功')
            this.modal = false
            this.getContentList()
            this.$refs.calendar.init()
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.modalLoading = false
        })
    },
    saveSurvey(cur, l) {
      this.modalLoading = true
      const { is_execute, remark, date, result } = cur
      clockPatientApi(
        l.id,
        {
          is_finish: 1,
          is_execute,
          remark: is_execute === 1 ? '' : remark,
          date: formatDate(date, null, 'yyyy-MM-dd hh:mm:ss'),
          result: is_execute === 1 ? '' : result,
        },
        l.extra
      )
        .then((res) => {
          this.modalLoading = false
          if (res.code === 0) {
            this.$Message.success('操作成功')
            this.modal = false
            this.getContentList()
            this.$refs.calendar.init()
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.modalLoading = false
        })
    },
    saveMedicine(cur, l) {
      const { is_execute, remark, date, result, dosages } = cur
      l.extra.medicines.forEach((item, index) => {
        item._dosage = item._dosage || item.dosage
        item.fact_dosage = dosages[index]
        item.dosage = dosages[index]
      });

      this.modalLoading = true
      clockPatientApi(
        l.id,
        {
          is_finish: 1,
          is_execute,
          remark,
          date: formatDate(date, null, 'yyyy-MM-dd hh:mm:ss'),
          result: is_execute === 1 ? '' : result,
        },
        l.extra
      )
        .then((res) => {
          this.modalLoading = false
          if (res.code === 0) {
            this.$Message.success('操作成功')
            this.modal = false
            this.getContentList()
            this.$refs.calendar.init()
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.modalLoading = false
        })
    },
    saveActivity(cur, l) {
      if (this.curActivity.type === 'article') {
        this.saveArticle(cur, l)
      }
      if (this.curActivity.type === 'survey') {
        this.saveSurvey(cur, l)
      }
      if (this.curActivity.type === 'medicine') {
        this.saveMedicine(cur, l)
      }
      if (this.curActivity.type === 'visit') {
        this.saveVisit(cur, l)
      }
    },
    editActivity(u) {
      this.curActivity = u
      this.modalTitle = u.title
      this.showModal()
    },
    showModal() {
      this.modal = true
    },
    hideModal() {
      this.modal = false
      this.modalLoading = false
    },
    calcWidth() {
      const { clientWidth } = this.$refs.contentForm || {}
      if (clientWidth >= 900) {
        this.formItemClass = 'flex-4'
        this.formDateClass = 'flex-8'
      } else if (clientWidth >= 600) {
        this.formItemClass = 'flex-6'
        this.formDateClass = 'flex-12'
      } else if (clientWidth >= 450) {
        this.formItemClass = 'flex-8'
        this.formDateClass = 'flex-16'
      } else {
        this.formItemClass = 'flex-12'
        this.formDateClass = 'flex-24'
      }
    },
    handleDateCancel() {
      this.query.time = ["", ""];
      this.getContentList();
    },
    handleDateConfirm() {
      this.getContentList()
    },
    handleDateChange(v) {
      this.query.time = v
    },
    handleHistoryClick(h) {
      this.historyId = h.id
      this.historyTitle = h.name
      this.historyModal = true
    },
    getTreatList(flag) {
      if (!this.info.user_id) return
      const { user_id } = this.info
      getPatientInfoApi({ patient_id: user_id }).then((res) => {
        if (res.code === 0) {
          this.treatList = res.data.templates
          if (this.treatList && this.treatList.length && flag) {
            this.currentTreat = res.data.templates[0].id
          } else {
            if (!this.treatList.find((t) => t.id === this.currentTreat)) {
              this.currentTreat = res.data.templates.length
                ? res.data.templates[0].id
                : ''
            }
          }
          this.getContentList()
          this.getHistoryList()
          this.$refs.calendar.init()
        }
      })
    },
    getCalendarDetail(value, range) {
      if (this.calendarRange[0] > value || this.calendarRange[1] < value) {
        this.getCalendar(value, range)
      }
      const current = this.calendarList.find((c) => c.date === value)
      let arr = []
      ;((current && current.schedules) || []).forEach((v) => {
        v.extra = (typeof v.extra === 'string') ? JSON.parse(v.extra) : v.extra;
        v.origin_extra = (typeof v.origin_extra === 'string') ? JSON.parse(v.origin_extra) : v.origin_extra;
        v.list = [];
        v.date_show = formatDate(new Date(v.start_time)) <= formatDate();
        this.type.forEach((t) => {
          (v.origin_extra[t.value + "s"] || []).map((item) => {
            item.type = t.value;
            item.type_name = t.text;
            item.extra = v.extra[t.value + "s"].find(e => e.id === item.id)
            v.list.push(item);
          });
        });
        arr.push(v);
      })
      this.currentCalendar = arr
      this.calendar = value
      this.calendarRange = range
    },
    getCalendar(value, range) {
      if (!this.currentTreat) {
        this.calendarList = []
        this.calendarDots = []
        this.calendarErrors = []
        this.currentCalendar = []
        return
      }
      const { user_id } = this.info
      this.currentCalendarLoading = true
      getPatientCalendarApi({
        patient_id: user_id,
        template_id: this.currentTreat,
        start_date: range[0],
        end_date: range[1],
      })
        .then((res) => {
          this.currentCalendarLoading = false
          if (res.code === 0) {
            this.calendarList = res.data
            this.calendarDots = res.data
              .filter((item) => item.schedules)
              .filter(
                (item) =>
                  item.schedules.filter(
                    (i) => i.is_finish === 0 || i.is_finish === 1
                  ).length > 0
              )
              .filter((item) => {
                return item.date > formatDate()
              })
            this.calendarErrors = res.data
              .filter((item) => item.schedules)
              .filter(
                (item) =>
                  item.schedules.filter((i) => i.is_finish === 0).length > 0
              )
              .filter((item) => {
                return item.date <= formatDate()
              })
            this.calendarSuccesses = res.data
              .filter((item) => item.schedules)
              .filter(
                (item) =>
                  item.schedules.filter((i) => i.is_finish === 1).length ===
                  item.schedules.length
              )
              .filter((item) => {
                return item.date <= formatDate()
              })
            this.calendarRange = range
            this.getCalendarDetail(value, range)
          }
        })
        .catch(() => {
          this.currentCalendarLoading = false
        })
    },
    getContentList() {
      if (!this.currentTreat) {
        this.list = []
        return
      }
      const { template_id, is_finish, event_type, type, time } = this.query
      const [start_date, end_date] = time
      const { user_id } = this.info
      this.currentContentLoading = true
      getPatientActivityListApi({
        patient_id: user_id,
        template_id: this.currentTreat,
        child_template_id: template_id ? template_id : '',
        is_finish,
        event_type,
        type,
        orders: 'start_time desc',
        start_time: start_date ? start_date + ' 00:00:00' : '',
        end_time: end_date ? end_date + ' 23:59:59' : '',
      })
        .then((res) => {
          this.currentContentLoading = false
          if (res.code === 0) {
            let arr = [];
            try {
              (res.data || []).forEach((v) => {
                const key = v.start_time.slice(0, 10)
                const day = new Date(key).getDay()
                const week = [
                  '星期日',
                  '星期一',
                  '星期二',
                  '星期三',
                  '星期四',
                  '星期五',
                  '星期六',
                ]
                if (!arr.find((a) => a.key === key)) {
                  arr.push({
                    key,
                    day: week[day],
                    list: [],
                  })
                }
                v.extra = JSON.parse(v.extra);
                v.origin_extra = JSON.parse(v.origin_extra);
                const a = arr.find(a => a.key === key);
                v.list = [];
                v.date_show = formatDate(new Date(v.start_time)) <= formatDate();
                this.type.forEach((t) => {
                  (v.origin_extra[t.value + "s"] || []).map((item) => {
                    item.type = t.value;
                    item.type_name = t.text;
                    item.extra = v.extra[t.value + "s"].find(e => e.id === item.id)
                    v.list.push(item);
                  });
                });
                a.list.push(v);
              })
              this.list = arr;
            } catch (error) {
              console.log(error)
            }
          }
        })
        .catch(() => (this.currentContentLoading = false))
    },
    getHistoryList() {
      this.historyLoading = true
      const { user_id } = this.info
      getPatientHistorySchemeListApi({ patient_id: user_id })
        .then((res) => {
          this.historyLoading = false
          if (res.code === 0) {
            this.historyList = res.data.filter(
              (d) => d.status !== 1 && d.status !== 0
            )
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.historyLoading = false
        })
    },
    getTemplate() {
      getSchemeDetailApi({ id: this.currentTreat }).then((res) => {
        if (res.code === 0) {
          this.templateList = res.data.child_templates || []
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    handleChangeTreat(value) {
      this.currentTreat = value
    },
    pausePatientMedicine() {
      this.$confirm('请再次确定是否暂停用药?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const data = {
            template_id: this.currentTreat,
            patient_id: this.info.patient_id || this.info.user_id,
            date: formatDate(new Date()),
          }
          pausePatientMedicineApi(data).then((res) => {
            if (res.code === 0) {
              this.$Message.success('操作成功')
              this.getTreatList()
            } else {
              this.$Message.error(res.message)
            }
          })
        })
        .catch(() => {})
    },
    resumePatientMedicine() {
      this.medicineModal = true
      this.curMedicine = {
        date: formatDate(new Date(), 1),
        resume_way: 1,
      }
    },
    cancelMedicineResumeModal() {
      this.medicineModal = false
      this.medicineModalLoading = false
    },
    cancelTreatResumeModal() {
      this.treatModal = false
      this.treatModalLoading = false
      this.$refs.form.resetFields()
    },
    saveMedicineResumeModal() {
      this.medicineModalLoading = true
      const data = {
        template_id: this.currentTreat,
        patient_id: this.info.patient_id || this.info.user_id,
        date: formatDate(this.curMedicine.date),
        first_missed_key_activity_date: formatDate(this.curMedicine.date),
        // resume_way: this.curMedicine.resume_way
      }
      resumePatientMedicineApi(data).then((res) => {
        this.medicineModalLoading = true
        if (res.code === 0) {
          this.$Message.success('操作成功')
          this.cancelMedicineResumeModal()
          this.getTreatList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    saveTreatResumeModal() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.treatModalLoading = true
          const data = {
            template_id: this.currentTreat,
            patient_id: this.info.patient_id || this.info.user_id,
            state: 1,
            date: formatDate(this.curModalTreat.date),
            first_missed_key_activity_date: formatDate(this.curModalTreat.date),
            resume_way: this.curModalTreat.resume_way,
            reason: this.curModalTreat.reason,
          }
          changeTemplateStateApi(data).then((res) => {
            this.treatModalLoading = true
            if (res.code === 0) {
              this.$Message.success('操作成功')
              this.cancelTreatResumeModal()
              this.getTreatList()
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    changeTemplateState(state) {
      let action_text
      if (state === 0) {
        action_text = '暂停'
      }
      if (state === 1) {
        this.treatModal = true
        this.curModalTreat = {
          date: formatDate(new Date(), 1),
          resume_way: 1,
          reason: '',
        }
        return
      }
      if (state === -1) {
        action_text = '终止'
      }
      if (state === 2) {
        action_text = '完成'
      }
      this.$prompt(`请再次确定是否${action_text}该方案?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\u4e00-\u9fa5()（）a-zA-Z0-9]{1,100}$/,
        inputPlaceholder: `请输入${action_text}该方案原因`,
        inputErrorMessage: `请输入由中英文、数字以及括号组成的不超过100长度的原因`,
      })
        .then(({ value }) => {
          changeTemplateStateApi({
            template_id: this.currentTreat,
            patient_id: this.info.patient_id || this.info.user_id,
            state,
            reason: value,
          }).then((res) => {
            if (res.code === 0) {
              this.$Message.success('操作成功')
              this.getTreatList()
            } else {
              this.$Message.error(res.message)
            }
          })
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="less">
.el-tooltip__popper {
  max-width: 70% !important;
}
.page-treatInfo {
  display: flex;
  flex-direction: row;

  .dot {
    position: relative;
    &::after {
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
      content: ' ';
      width: 8px;
      height: 8px;
      background: #c0c4cc;
      border-radius: 50%;
    }
    &.success::after {
      background: #3eca9a;
    }
    &.warning::after {
      background: #ff9e00;
    }
    &.error::after {
      background: #ed4014;
    }
  }
  .treat-operate-btns {
    display: flex;
    justify-content: space-between;
    padding: 0 20px 20px;
  }
  .treat-operate-btn {
    flex: 1;
    box-sizing: border-box;
    border-color: #4286f1;
    background-color: #fff;
    padding: 10px 8px;
  }
  .treatInfo-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    padding: 0 0 0 16px;
    margin-bottom: 12px;
  }
  .content-list {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 300px;
    flex-grow: 1;
    padding: 16px;
  }
  .content-reason {
    opacity: 0.7;
    padding-left: 16px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .item {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    text-align: right;
  }
  .content-form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    &-item {
      padding: 0 8px 8px;
      min-width: 150px;
    }
    &-item-date {
      padding: 0 8px 8px;
      min-width: 300px;
    }
    .flex-6 {
      flex: 0 0 25%;
    }
    .flex-12 {
      flex: 0 0 50%;
    }
    .flex-4 {
      flex: 0 0 16.67%;
    }
    .flex-8 {
      flex: 0 0 33.32%;
    }
    .flex-16 {
      flex: 0 0 66.64%;
    }
    .flex-24 {
      flex: 0 0 100%;
    }
  }
  .calendar-list {
    position: relative;
    max-width: 380px;
    padding: 16px;
    flex: 0 0 30%;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e4e7ed;
  }
  .history-title {
    margin-bottom: 4px;
    > span {
      vertical-align: middle;
      line-height: normal;
    }
    .tag {
      display: inline-block;
      margin-left: 4px;
      color: #fff;
      padding: 2px 4px;
      border-radius: 4px;
      font-size: 12px;
      &.success {
        background: #3eca9a;
      }
      &.warning {
        background: #ff9e00;
      }
      &.error {
        background: #ed4014;
      }
    }
  }
  .key-list {
    padding: 16px 16px 16px 0;
    max-width: 320px;
    flex: 0 0 25%;
    display: flex;
    flex-direction: column;
  }
  .schedule-list {
    position: relative;
    margin-top: 20px;
    padding-right: 16px;
    overflow-y: auto;
    .schedule-title {
      color: #b4c1d4;
      position: relative;
      &::before {
        position: absolute;
        content: ' ';
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        left: -30px;
        background: #5d7ff8;
        border-radius: 50%;
      }
      &::after {
        position: absolute;
        content: ' ';
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
        left: -24px;
        background: #fff;
        border-radius: 50%;
      }
    }
    .schedule-item {
      position: relative;
      padding-left: 30px;
      margin-bottom: 20px;
      &::after {
        position: absolute;
        content: ' ';
        top: 30px;
        left: 10px;
        width: 1px;
        height: calc(~' 100% ' - ~' 20px ');
        background: #e4e7ed;
      }
      &:last-child {
        &::after {
          content: none;
        }
      }
    }
  }
  .calendar-btn-wrap {
    padding: 2px 4px 2px 2px;
    overflow-y: auto;
  }
}
</style>
